import React from "react";
import "./Loader.scss";
const Loader = () => {
  return <div class="loading">Loading&#8230;</div>;
};

export default Loader;
